import { Component, inject, signal } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';

@Component({
  templateUrl: './warning-dialog.component.html',
  styleUrl: './warning-dialog.component.scss',
  imports: [MatButtonModule],
})
export class WarningDialogComponent {
  public dialog = inject(MatDialogRef<WarningDialogComponent>);

  private data = inject(MAT_DIALOG_DATA) as {
    title: string;
    message: string;
    buttonConfirm: string;
    buttonCancel: string;
  };

  readonly title = signal(this.data.title);
  readonly message = signal(this.data.message);
  readonly buttonConfirm = signal(this.data.buttonConfirm);
  readonly buttonCancel = signal(this.data.buttonCancel);

  confirm() {
    this.dialog.close(true);
  }

  cancel() {
    this.dialog.close(false);
  }
}
